export const offerIncludes: string[] = [
  '6 Complete Volumes of drawing instruction',
  '150 Ready-to-Teach Lessons organized by skill',
  '150 Drawing Exercises with timing and cues',
  'Correction & Signal Library for professional feedback',
  '50 Creative Projects for all levels',
  'Course & Workshop Builders to structure programs',
  'Emergency Rescue Systems for unexpected situations',
  'Class Finder to locate lessons instantly',
  'Progress Tracking Tools built in',
  '7-Day Money-Back Guarantee, no questions asked',
  'Instant Access to all materials',
]

export const everythingIncluded: string[] = [
  'Volume 1: Drawing Foundations & Visual Language',
  'Volume 2: Observation, Proportion & Construction',
  'Volume 3: Perspective, Space, Light & Composition',
  'Volume 4: Figure, Portrait, Anatomy & Advanced Rendering',
  'Volume 5: Complete Structured Progression',
  'Volume 6: 150 Ready-to-Teach Lessons',
  'Bonus 1: 150 Drawing Exercises Ready to Teach',
  'Bonus 2: Drawing Correction Library & Teacher Signals',
  'Bonus 3: 50 Creative Drawing Projects',
  'Bonus 4: Drawing Course, Workshop & Lesson Builder',
  'Bonus 5: Drawing Rescue Vault',
  'Class Finder System',
  'Progress Tracking Tools',
  '7-Day Money-Back Guarantee',
  'Instant Digital Access',
]

export const painCosts: string[] = [
  'Hours lost searching for exercises that work together and flow naturally',
  'Classes that feel repetitive because you keep returning to the same activities',
  'Visible improvisation that\u2019s quietly undermining your confidence as a teacher',
  'No variety in technical focus week to week—and students who plateau without knowing why',
  'Weekends spent planning instead of resting, recovering, or living your life',
  'Mixed-level classes that feel chaotic because you don\u2019t have organized alternatives',
  'No clear way to track student progress or show parents what their children are achieving',
  'Last-minute scrambling when a lesson doesn\u2019t land the way you\u2019d hoped',
]

export const noMore: string[] = [
  'No more Sunday nights searching for exercises that flow',
  'No more rushed or improvised classes',
  'No more students plateauing because lessons feel the same',
  'No more lost weekends on planning instead of living',
  'No more entering class wishing you\u2019d prepared more',
  'No more chaos with mixed-level groups',
  'No more guessing if your students are really progressing',
]
